import React, { useState, useContext, createContext } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// 1. Create the Context
const TooltipContext = createContext();

// 2. Create the Provider component
export function TooltipProvider({ children }) {
    const [tooltip, setTooltip] = useState(null); // { content: '...', position: { x: 0, y: 0 } }

    const showTooltip = (content, event) => {
        // Position the tooltip slightly below and centered on the cursor
        const position = { x: event.clientX, y: event.clientY};
        setTooltip({ content, position });
    };

    const hideTooltip = () => {
        setTooltip(null);
    };

    return (
        <TooltipContext.Provider value={{ showTooltip, hideTooltip }}>
            {children}
            <AnimatePresence>
                {tooltip && (
                    <motion.div
                        className="tooltip"
                        initial={{ opacity: 0, y: -40, x: "-50%", scale: 0.9 }}
                        animate={{ opacity: 1, y: -50, x: "-50%", scale: 1 }}
                        exit={{ opacity: 0, y: -40, x: "-50%", scale: 0.9 }}
                        transition={{ duration: 0.15, ease: 'easeOut' }}
                        style={{
                            left: tooltip.position.x,
                            top: tooltip.position.y,
                        }}
                    >
                        {tooltip.content}
                    </motion.div>
                )}
            </AnimatePresence>
        </TooltipContext.Provider>
    );
}

// 3. Create the custom hook for easy access
export const useTooltip = () => {
    return useContext(TooltipContext);
};